import { Component } from 'opus-angular-seed-core';

@Component({
    require: {
        formRowWide: '^formRowWide'
    },
    template: `
        <p ng-if="vm.formRowWide.error" class="desc error">{{ vm.formRowWide.error }}</p>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/form/row/wide/error/index.js